import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { Flex, Text, Title, rem } from '@mantine/core';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import {
	PredefinedIconSize,
	PredefinedIcons,
} from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

interface Props {
	title?: string;
	description?: string;
	onContainerClick?: () => void;
	style?: React.CSSProperties;
	icon?: PredefinedIcons;
	iconSize?: PredefinedIconSize;
	dataTestId?: string;
}

export const EmptyState = ({
	title,
	description,
	onContainerClick,
	children,
	style = {},
	icon = 'es-box-flying-papers',
	iconSize = 'md',
	dataTestId,
}: PropsWithChildren<Props>) => {
	const styles = {
		overflow: 'hidden',
		...(onContainerClick ? { cursor: 'pointer' } : {}),
		...style,
	};

	return (
		<Flex
			direction="column"
			align="center"
			justify="center"
			h="100%"
			w="100%"
			m="auto"
			style={styles}
			onClick={() => onContainerClick && onContainerClick()}
			data-testid={dataTestId}
		>
			<Flex direction="column" align="center" justify="center" gap="0.5rem" maw="50%">
				<Flex align="center" justify="center">
					<NoDataIcon variant={icon} iconSize={iconSize} />
				</Flex>
				<Flex direction="column" align="center" justify="center" gap="0.25rem">
					{title ? (
						<Title fw={200} c="dark.8" order={4} ta="center">
							{title}
						</Title>
					) : null}
					{description ? (
						<Text fw={400} c="dark.0" ta="center">
							{description}
						</Text>
					) : null}
				</Flex>
				{children}
			</Flex>
		</Flex>
	);
};

const NoDataIcon = styled(Icon)<{ iconSize: PredefinedIconSize }>`
	&.svg {
		${({ iconSize }) => {
			switch (iconSize) {
				case 'sm':
					return `width: ${rem('120px')}; height: auto`;
				case 'md':
					return `width: ${rem('198px')}; height: auto`;
				case 'lg':
					return `width: ${rem('256px')}; height: ${rem('256px')}`;
				default:
					return 'width: 25rem; height: 22rem;';
			}
		}}}
	}
`;
